import React, { useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import { AppContext } from "./context/AppContext";
import MainLayout from "./layouts/MainLayout";
import Login from "./pages/Login";
import Home from "./pages/Inicio";
import Secundario from "./pages/Secundario";
import Principal from "./pages/Principal";
import Preguntas from "./pages/Preguntas";
import Usuarios from "./pages/Usuarios";
import RechazoServicio from "./pages/RechazoServicio";
import RechazoComercial from "./pages/RechazoComercial";
import Error404 from "./pages/errors/Error404";
import './App.css'

function App() {
  const AuthGuard = ({ children, requireAuth = true }) => {
    const { isAuthenticated } = useContext(AppContext);

    if (requireAuth && !isAuthenticated) {
      return <Navigate to="/login" replace />;
    }

    if (!requireAuth && isAuthenticated) {
      return <Navigate to="/" replace />;
    }

    return children;
  };

  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <AuthGuard requireAuth={false}>
                <Login />
              </AuthGuard>
            }
          />

          <Route
            path="/"
            element={
              <AuthGuard requireAuth={true}>
                <MainLayout />
              </AuthGuard>
            }
          >
            <Route index element={<Home />} />
            <Route path="principal" element={<Principal />} />
            <Route path="secundario" element={<Secundario />} />
            <Route path="preguntas" element={<Preguntas />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="rechazo-servicio" element={<RechazoServicio />} />
            <Route path="rechazo-comercial" element={<RechazoComercial />} />
            {/* Agrega más rutas aquí */}
          </Route>

          <Route path="/404" element={<Error404 />} />
          <Route path="*" element={<Navigate to="/404" />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
